import apiClient from '../../../Services/ApiClient';

export interface WorkplaceUpdateData {
	parentWorkplaceId?: string;
	name?: string;
	codeName?: string;
	phone?: string;
	address?: object;
	calendarEmailNotification?: boolean;
	memberSearchableOutside?: boolean;
	workplaceSearchableOutside?: boolean;
	createCaseTarget?: string;
	onlineOrderTarget?: string;
	defaultDoctorId?: string | null;
	defaultInvitation?: boolean;
	workplaceP1Region?: string;
	workplaceP1Oid?: string;
	workplaceP1Extension?: string;
	termItems?: { id: string }[];
	meta?: { key: string; value: string | Record<string, string | number> }[];
}

export const updateWorkplaceData = async (
	workplaceId: string,
	data: WorkplaceUpdateData,
) => {
	return await apiClient.patch(`/workplaces/${workplaceId}`, data);
};
